import { render, staticRenderFns } from "./PatientMemberCard.vue?vue&type=template&id=2abe6f23&scoped=true"
import script from "./PatientMemberCard.vue?vue&type=script&lang=js"
export * from "./PatientMemberCard.vue?vue&type=script&lang=js"
import style0 from "./PatientMemberCard.vue?vue&type=style&index=0&id=2abe6f23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe6f23",
  null
  
)

export default component.exports